import React, { ReactNode } from 'react';

import { ReactComponent as SettingIcon } from '@asd-stan/ui-kit/assets/icons/dark-setting.svg';

import { StyledButtonWithSettings } from './button.styled';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	title?: string;
	onClick?: () => void;
	onClickSettings?: () => void;
	icon?: ReactNode | undefined;
	secondary?: boolean;
	type?: 'button' | 'submit' | 'reset';
	fullWidth?: boolean;
	disabled?: boolean;
	flat?: boolean;
	className?: string;
}

export const ButtonWithSettings: React.FC<ButtonProps> = ({
	title,
	onClick,
	onClickSettings,
	icon,
	secondary,
	type = 'button',
	fullWidth,
	disabled,
	flat,
	...props
}) => {
	return (
		<StyledButtonWithSettings
			$secondary={secondary}
			$fullWidth={fullWidth}
			$disabled={disabled}
			$flat={flat}
			$title={!!title}>
			<button title={title} onClick={onClick} disabled={disabled} {...props}>
				<span>{icon}</span>
				{title}
			</button>
			<button disabled={disabled} onClick={onClickSettings} className="settings">
				{<SettingIcon />}
			</button>
		</StyledButtonWithSettings>
	);
};